/**
 * Curated IANA timezone list used by the onboarding Workspace step
 * and the Settings → Workspace page. Ordered by primary-market
 * priority (Asia / Australia / Pacific first, then North America,
 * then Europe, with UTC as a safe fallback).
 *
 * Keep this list in sync with the values the backend accepts on
 * `PATCH /api/v1/tenants/me`. Adding a new region? Append it here.
 */
export const TIMEZONES = [
  "Asia/Manila",
  "Asia/Hong_Kong",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Asia/Bangkok",
  "Asia/Jakarta",
  "Australia/Sydney",
  "Pacific/Auckland",
  "America/Los_Angeles",
  "America/Denver",
  "America/Chicago",
  "America/New_York",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "UTC",
] as const;

export type Timezone = (typeof TIMEZONES)[number];
